import { FC } from 'react'
import { Tooltip as BaseTooltip, PlacesType } from 'react-tooltip'
import styled, { useTheme } from 'styled-components'

type TooltipProps = {
	id: string
	trigger: React.ReactNode
	content: React.ReactNode
	place?: PlacesType
}

const Tooltip: FC<TooltipProps> = ({ id, trigger, content, place = 'top', ...props }) => {
	const theme = useTheme()
	return (
		<Container {...props}>
			<div data-tooltip-id={id}>{trigger}</div>
			<BaseTooltip
				id={id}
				border={theme.colors.selectedTheme.newTheme.tooltip.border}
				className="tooltip"
				place={place}
			>
				{content}
			</BaseTooltip>
		</Container>
	)
}

const Container = styled.div`
	.tooltip {
		background-color: ${(props) => props.theme.colors.selectedTheme.newTheme.tooltip.background};
		opacity: 1;
		border-radius: 6px;
		min-width: 200px;
		max-width: 300px;
	}
`

export default Tooltip
